import {
  START_TEACHING_LANDING, EMAIL_REGISTRATION, STEP_PERSONAL_INFO, STEP_LANGUAGES,
  STEP_TEACHING_COURSES, STEP_TEACHING_PRICE, STEP_EDUCATION_DEGREES,
  STEP_WORK_EXPERIENCES, STEP_CERTIFICATES, STEP_PROFILE_PICTURE, STEP_TEACHER_ABOUT,
  STEP_INTRO_VIDEO, STEP_WORK_TIME, STEP_DOCUMENTS, UPLOAD_DOCUMENTS, REMOVE_DOCUMENTS,
  STEP_TACKING, CHECK_YOUTUBE_LINK
} from '@endpoints'
import { cloneObjectWithException } from '@helper/utils'
import {
  STORE_BEST_TEACHERS,
  STORE_FAQS,
  STORE_PERSONAL_INFO,
  STORE_STATISTIC,
  STORE_TESTIMONIAL,
  UPDATE_PERSONAL_INFO,
  STORE_TEACHING_COURSES,
  STORE_META,
  STORE_TEACHING_PRICE,
  STORE_EDUCATION_DEGREES,
  STORE_WORK_EXPERIENCES,
  STORE_CERTIFICATES,
  STORE_PROFILE_PICTURE,
  STORE_TEACHER_ABOUT,
  STORE_INTRO_VIDEO,
  STORE_WORK_TIME,
  STORE_DOCUMENTS,
  STORE_TRACKING,
  STORE_LANGUAGES,
  STORE_INTRODUCTION,
  STORE_SEO_CONTENT, STORE_INTERNAL_LINKS, STORE_BREADCRUMB,
  STORE_STEP_STATUS, STORE_CURRENCY, STORE_START_TEACHING_PRICE_CHART, STORE_TAGLINE,
  STORE_JOIN_US
} from '../mutation-types'

export async function asyncDataLanding ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: START_TEACHING_LANDING.url,
      useCache: START_TEACHING_LANDING.cache
    })
    const data = response?.data
    if (data) {
      commit(STORE_STEP_STATUS, data?.start_teaching_status)
      commit(STORE_START_TEACHING_PRICE_CHART, data?.price_chart)
      commit(STORE_TAGLINE, data?.tagline)
      commit(STORE_INTRODUCTION, data?.introduction)
      commit(STORE_JOIN_US, data?.join_us)
      commit('global/' + STORE_STATISTIC, data?.statistics, { root: true })
      commit('global/' + STORE_TESTIMONIAL, data?.testimonials, { root: true })
      commit('global/' + STORE_BEST_TEACHERS, data?.best_teachers, { root: true })
      commit('global/' + STORE_FAQS, data?.faq, { root: true })
      commit('global/' + STORE_META, data?.meta, { root: true })
      commit('global/' + STORE_SEO_CONTENT, data?.content, { root: true })
      commit('global/' + STORE_INTERNAL_LINKS, data?.internal_links, { root: true })
      commit('global/' + STORE_BREADCRUMB, data?.breadcrumb, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataPersonalInfo ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_PERSONAL_INFO
    })
    const data = response?.data
    if (data) {
      commit(STORE_PERSONAL_INFO, data)
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataLanguages ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_LANGUAGES
    })
    const data = response?.data
    if (data) {
      commit(STORE_LANGUAGES, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataTeachingCourses ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_TEACHING_COURSES
    })
    const data = response?.data
    if (data) {
      commit(STORE_TEACHING_COURSES, data?.course_tree)
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataTeachingPrice ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_TEACHING_PRICE
    })
    const data = response?.data
    if (data) {
      commit(STORE_TEACHING_PRICE, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
      commit('global/' + STORE_CURRENCY, data?.currency, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataEducationDegrees ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_EDUCATION_DEGREES
    })
    const data = response?.data
    if (data) {
      commit(STORE_EDUCATION_DEGREES, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataWorkExperiences ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_WORK_EXPERIENCES
    })
    const data = response?.data
    if (data) {
      commit(STORE_WORK_EXPERIENCES, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataCertificates ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_CERTIFICATES
    })
    const data = response?.data
    if (data) {
      commit(STORE_CERTIFICATES, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataProfilePicture ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_PROFILE_PICTURE
    })
    const data = response?.data
    if (data) {
      commit(STORE_PROFILE_PICTURE, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataTeacherAbout ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_TEACHER_ABOUT
    })
    const data = response?.data
    if (data) {
      commit(STORE_TEACHER_ABOUT, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataIntroVideo ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_INTRO_VIDEO
    })
    const data = response?.data
    if (data) {
      commit(STORE_INTRO_VIDEO, data?.youtube)
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataWorkTime ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_WORK_TIME
    })
    const data = response?.data
    if (data) {
      commit(STORE_WORK_TIME, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncDataDocuments ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_DOCUMENTS
    })
    const data = response?.data
    if (data) {
      commit(STORE_DOCUMENTS, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function asyncTracking ({ commit }) {
  try {
    const response = await this.$api.get({
      errorType: 'page',
      url: STEP_TACKING
    })
    const data = response?.data
    if (data) {
      commit(STORE_TRACKING, cloneObjectWithException(data, 'meta'))
      commit('global/' + STORE_META, data?.meta, { root: true })
    }
  } catch (e) {
  }
}
export async function emailRegistration ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: EMAIL_REGISTRATION,
      payload
    })
    if (response && response?.data) {
      return response.data
    }
  } catch (err) {
  }
}
export function updatePersonalInfo ({ commit }, payload) {
  commit(UPDATE_PERSONAL_INFO, payload)
}
export async function postPersonalInfo ({ commit, app, state }) {
  try {
    const response = await this.$api.post({
      url: STEP_PERSONAL_INFO,
      payload: { ...state.personalInfo }
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postLanguages ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_LANGUAGES,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postTeachingCourse ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_TEACHING_COURSES,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postTeachingPrice ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_TEACHING_PRICE,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postEducationDegrees ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_EDUCATION_DEGREES,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postWorkExperiences ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_WORK_EXPERIENCES,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postCertificates ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_CERTIFICATES,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postProfilePicture ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_PROFILE_PICTURE,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postTeacherAbout ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_TEACHER_ABOUT,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postIntroVideo ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_INTRO_VIDEO,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postWorkTime ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: STEP_WORK_TIME,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postDocuments ({ commit, app, state }) {
  try {
    const response = await this.$api.post({
      url: STEP_DOCUMENTS
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function postUploadedDocument ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: UPLOAD_DOCUMENTS,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function removeUploadedDocument ({ commit, app, state }, payload) {
  try {
    const response = await this.$api.post({
      url: REMOVE_DOCUMENTS,
      payload
    })
    if (response && response?.data) {
      return response
    }
  } catch (err) {
  }
}
export async function checkYoutubeLink ({ commit }, payload) {
  try {
    const response = await this.$api.get({
      url: CHECK_YOUTUBE_LINK,
      query: payload,
      errorType: 'none'
    })
    return response
  } catch (err) {
    return err
  }
}
